<template>
  <v-container class="index-page">
    <v-row>
      <v-col md="9">
        <v-row class="mb-6">
          <v-col :key="i" v-for="(levelItem, i) in levelItems">
            <level-item :heading="$t(levelItem.heading)" :title="levelItem.title"></level-item>
          </v-col>
        </v-row>
        <v-card class="mb-8">
          <v-row class="mb-8">
            <v-col cols="12" xl="6">
              <v-card-text>
                <div class="rectangle is-5by3">
                  <chart :dataSets="chartPeriodSummary"></chart>
                </div>
              </v-card-text>
            </v-col>
            <v-col cols="12" xl="6">
              <v-card-text>
                <div class="rectangle is-5by3">
                  <chart :dataSets="avgDistanceSummary"></chart>
                </div>
              </v-card-text>
            </v-col>
          </v-row>
        </v-card>
        <v-card>
          <v-card-title>{{ $t('index.realTimeInformation') }}</v-card-title>
          <v-row class="pa-4">
            <v-col>
              <div class="map-wrap">
                <google-map :zoom="range.zoom" :stations="stations" :center="range.position" :options="{ showSiteStatusColor: true }" @selectStation="setCurrentStation"></google-map>
              </div>
            </v-col>
            <v-col>
              <div class="site-status-block">
                <site-status :data="currentStation" type="simple"></site-status>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col md="3">
        <v-col>
          <v-row>
            <appointment-schedule></appointment-schedule>
          </v-row>
        </v-col>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import LevelItem from '@/components/LevelItem'
import GoogleMap from '@/components/GoogleMap'
import SiteStatus from '@/components/SiteStatus'
import Chart from '@/components/Charts/BarDefault'
import AppointmentSchedule from '@/components/AppointmentSchedule'
import { FAKE_SITE_INFO } from '@/libs/fakeData'

export default {
  components: { LevelItem, AppointmentSchedule, Chart, SiteStatus, GoogleMap },
  data () {
    return {
      siteInfo: FAKE_SITE_INFO
    }
  },
  computed: {
    ...mapGetters({
      stations: 'station/list',
      range: 'range/data',
      currentStation: 'station/currentStation'
    }),
    levelItems: () => [
      { heading: 'index.dailyRevenue', title: 82.4 },
      { heading: 'index.rentals', title: 285 },
      { heading: 'index.availableRent', title: 342 },
      { heading: 'index.availableReturn', title: 82 }
    ],
    chartPeriodSummary () {
      return {
        title: this.$t('periodSummary.title'),
        dataName: this.$t('periodSummary.dataName'),
        tooltip: {
          trigger: 'axis',
          formatter: this.$t('periodSummary.toolTips')
        },
        xAxis: {
          data: ['09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00']
        },
        data: [8800, 7000, 9006, 1030, 4000, 200, 1, 8000]
      }
    },
    avgDistanceSummary () {
      return {
        title: this.$t('avgDistance.title'),
        dataName: this.$t('avgDistance.dataName'),
        tooltip: {
          trigger: 'axis',
          formatter: this.$t('avgDistance.toolTips')
        },
        xAxis: {
          data: ['09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00']
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: (value) => {
              if (value < 1000) return this.$t('avgDistance.yAxisLable.m', { value })
              return this.$t('avgDistance.yAxisLable.km', { value: value / 1000 })
            }
          }
        },
        data: [500, 1400, 1980, 1560, 1050, 1492, 300, 1990]
      }
    }
  },
  methods: {
    ...mapActions({
      selectStation: 'station/select'
    }),
    setCurrentStation ({ id }) {
      this.selectStation(id)
    }
  }
}
</script>

<style lang="stylus" scoped>
  .index-page
    .site-status-block >>> .v-card
      box-shadow none
</style>
